import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import Disease from "../components/DiseasesList";


const UsersListPage = () => {
  return (
    <>

      {/* MasterLayout */}
      {/* <MasterLayout> */}

        {/* Breadcrumb */}
        <Breadcrumb title="Disease" />

        {/* UsersListLayer */}
        <Disease />

      {/* </MasterLayout> */}

    </>
  );
};

export default UsersListPage; 
